export default __webpack_public_path__ + "static/media/bkg--masterplan.12f08e49.jpg";